import { Component, Input} from '@angular/core';
import { TeiasoftToasterService } from '../../../shared/services/teiasoft-bucket/teiasoft-toaster.service';

@Component({
  selector: 'teiasoft-toast',
  templateUrl: './teiasoft-toast.component.html',
  styleUrls: ['./teiasoft-toast.component.scss']
})

export class TeiasoftToastComponent {
  @Input() message: string = "Lorem ispum dolor simet abracadabra";
  @Input() messageType: string = "";
  @Input() isMobile: boolean = false;

  toasterList:any[] = new Array();
  
  constructor(private teiasoftToasterService: TeiasoftToasterService){
    this.teiasoftToasterService.teiasoftToasterStart$.subscribe(
      (res) => {
        if (res != ''){
          if (!this.toasterList) this.toasterList = new Array();
          let _item: any = {};
          // "type|message|id": the message itself may contain "|", so only the first and last separators count
          const raw: string = res.toString();
          const typeEnd = raw.indexOf("|");
          const idStart = raw.lastIndexOf("|");
          _item.messageType = typeEnd === -1 ? raw : raw.substring(0, typeEnd);
          _item.message = typeEnd === -1 ? '' : raw.substring(typeEnd + 1, idStart > typeEnd ? idStart : undefined);
          _item.id = idStart > typeEnd ? raw.substring(idStart + 1) : '';
          this.toasterList.push(_item);
          setTimeout(() => {
            let _tToaster:any = document.getElementById("tToaster" + _item.id);
            if (_tToaster){
              _tToaster.classList.add("tl-visible");
              setTimeout(() => {
                this.onCloseToastClick(_item.id);
              }, 2500);
            }
          }, 50);
        }
      });
  }

  onCloseToastClick(toasterId: string){
    let _tToaster:any = document.getElementById("tToaster" + toasterId);
    if (!_tToaster) return;
    _tToaster.classList.remove("tl-visible");
    this.toasterList.splice(this.toasterList.findIndex(x => x.id == toasterId), 1);
  }

  setToastBottom(i:number): string{
    if (i == 0) {
      return "2vh";
    } else {
      return ((i*10) + ((i+1)*2)).toString() + "vh";
    }
  }
   
}
